<mat-card appearance="outlined" class="se-block" *ngIf="annotations?.length > 0">
  <mat-card-header>
    <mat-card-title class="se-title">{{ 'GLOBAL_ANNOTATIONS' | translate }}</mat-card-title>
  </mat-card-header>

  <table class="measure-table">
    <tr>
      <th scope="col">{{'NAME' | translate}}</th>
      <th scope="col">{{'VALUE' | translate}}</th>
      <th scope="col">{{'UDM' | translate}}</th>
    </tr>
    <tr *ngFor="let annotation of annotations">
      <td class="cell-name">{{annotation.name}}</td>
      <td>{{annotation.value}}</td>
      <td class="cell-udm">{{annotation.udM}}</td>
    </tr>
  </table>

</mat-card>
